import { Card, ImagesType } from '../types/types';
export const images: ImagesType[] = [
  {
    title: 'Deadpool',
    image: 'https://lumiere-a.akamaihd.net/v1/images/image_299ffd51.jpeg?region=0%2C0%2C1800%2C968',
  },

  {
    title: 'Marvel',
    image: 'https://cdn.shazoo.ru/336747_mHsafem7BI_avengers_infinity_war_2018_after.jpg',
  },
  {
    title: 'Spider-Man',
    image: 'https://i.pinimg.com/originals/d8/33/e8/d833e869b25951bb264b92466ecb5d4a.jpg',
  },
  {
    title: 'DC',
    image:
      'https://c4.wallpaperflare.com/wallpaper/983/757/183/batman-begins-wallpaper-preview.jpg',
  },
  {
    title: 'X-MEN',
    image:
      'https://fsmedia.imgix.net/06/b2/db/40/fd19/465c/bb31/18a3644f340c/hugh-jackman-as-wolverine.jpeg?rect=0,150,2400,1200&w=1024&dpr=1&auto=format&q=75',
  },
];
export const db: Card[] = [
  {
    id: 1,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIUx95HCcc7F_GRwV4oc2dIYKlekTnpy8SXxWM1AGk&s',
    name: 'Marvel:Captain America Shield',
    age: 300,
    rate: 9,
    favorite: false,
    description:
      'The iconic shield wielded by Captain America, made of Vibranium, a rare metal that absorbs and redirects vibrations, making it virtually indestructible.',
  },
  {
    id: 2,
    image: 'https://i.etsystatic.com/19286482/r/il/96c0fd/2980731281/il_1080xN.2980731281_j8z4.jpg',
    name: 'Marvel:Iron Man Helmet',
    age: 1000,
    rate: 8,
    favorite: true,
    description:
      'The high-tech helmet worn by Tony Stark as Iron Man, equipped with an AI assistant, long-range sensors, and a retractable visor.',
  },
  {
    id: 3,
    image:
      'https://static.wikia.nocookie.net/spiderman-films/images/3/36/WebshootersfromTheAmazingSpider-Man2%28film%29.png/revision/latest?cb=20170626215043',
    name: 'Spider-Man:Spider-Man Web Shooters',
    age: 200,
    rate: 7,
    favorite: false,
    description:
      'The wrist-mounted devices used by Spider-Man to shoot webs, swing through the city, and trap enemies. Comes with a built-in camera and GPS tracker.',
  },
  {
    id: 4,
    image:
      'https://oyster.ignimgs.com/mediawiki/apis.ign.com/the-dark-knight-rises/8/84/Belt_batman_forever_2.jpg',
    name: 'DC:Batman Utility Belt',
    age: 500,
    rate: 9,
    favorite: true,
    description:
      'The iconic belt worn by Batman, filled with various gadgets and tools, including batarangs, smoke pellets, and grappling hooks.',
  },
  {
    id: 6,
    name: 'Spider-Man:Venom Symbiote',
    age: 1500,
    rate: 10,
    favorite: true,
    image:
      'https://mir-s3-cdn-cf.behance.net/projects/404/b256a7160691805.Y3JvcCwxMDI0LDgwMCwwLDc4.png',
    description:
      'The black alien symbiote that bonds with hosts to create the villainous Venom. Provides enhanced strength, agility, and shape-shifting abilities, as well as a vulnerability to fire and sonics.',
  },
  {
    id: 7,
    name: 'DC:Green Lantern Power Ring',
    age: 800,
    rate: 9,
    image:
      'https://static.wikia.nocookie.net/heroism/images/3/37/Green_Lantern_Ring.jpg/revision/latest?cb=20170620132526',
    favorite: false,
    description:
      "The ring worn by members of the Green Lantern Corps, powered by the wearer's willpower and imagination. Allows for flight, energy projection, and the creation of solid constructs.",
  },
  {
    id: 8,
    name: 'Marvel:Thor Mjolnir Hammer',
    age: 1200,
    rate: 10,
    image:
      'https://cdn.shopify.com/s/files/1/0009/3719/7619/products/hammer-0805_800x.jpg?v=1636643463',
    favorite: true,
    description:
      'The enchanted hammer wielded by Thor, god of thunder. Can only be lifted by those deemed worthy, and grants its wielder the power of lightning, weather manipulation, and flight.',
  },
  {
    id: 9,
    name: 'Marvel:Wonder Woman Lasso of Truth',
    age: 600,
    rate: 8,
    image: 'https://www.comingsoon.net/wp-content/uploads/sites/3/2020/05/ww1984header.jpg',
    favorite: false,
    description:
      'The golden lasso wielded by Wonder Woman, imbued with the power of truth. Forces those bound by it to tell the truth and obey the commands of the wielder.',
  },
  {
    id: 10,
    name: 'Marvel:Doctor Strange Eye of Agamotto',
    age: 900,
    rate: 9,
    image: 'https://i.etsystatic.com/19286482/r/il/e642e6/1959075591/il_570xN.1959075591_b84l.jpg',
    favorite: true,
    description:
      'The mystical amulet worn by Doctor Strange, containing the Time Stone. Allows for time manipulation',
  },

  {
    id: 11,
    name: 'Marvel:Mind Stone',
    age: 1500,
    rate: 7,
    image:
      'https://static.wikia.nocookie.net/shaniverse/images/2/21/-mind-render.jpg/revision/latest?cb=20200607223954',
    favorite: false,
    description:
      'One of the six Infinity Stones, the Mind Stone grants its owner the ability to control the minds of others.',
  },
  {
    id: 12,
    name: 'Marvel:Power Stone',
    age: 2000,
    rate: 8,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQ1PFX0iEigkAq7nZU2Vm0zdYR9F1WTLk7Ew&usqp=CAU',
    favorite: false,
    description:
      'One of the six Infinity Stones, the Power Stone grants its owner immense strength and the ability to manipulate energy.',
  },
  {
    id: 13,
    name: 'Marvel:Time Stone',
    age: 2500,
    rate: 9,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS71sdoTM17AlbTFWKzTa3m13Mea9nbDte6BA&usqp=CAU',
    favorite: false,
    description:
      'One of the six Infinity Stones, the Time Stone grants its owner the ability to manipulate time and control the past, present, and future.',
  },
  {
    id: 14,
    name: 'Marvel:Space Stone',
    age: 3000,
    rate: 8,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIt2cubTor_tWcnjPGW6R5CMRHpYHiF_veew&usqp=CAU',
    favorite: false,
    description:
      'One of the six Infinity Stones, the Space Stone grants its owner the ability to travel through space, teleport objects, and create portals.',
  },
  {
    id: 15,
    name: 'Marvel:Reality Stone',
    age: 3500,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ79fGWhMPnVjmax9mbWWxfz-pZbMcLuESmzg&usqp=CAU',
    favorite: false,
    description:
      'One of the six Infinity Stones, the Reality Stone grants its owner the ability to alter reality and bend the laws of physics to their will.',
  },

  {
    id: 16,
    name: "DC:Joker's Acid-Squirting Flower",
    age: 150,
    rate: 6,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSSHHpUdxmbc57zDnVZ5nb1mRjU5bDB5fo0A&usqp=CAU',
    favorite: false,
    description: 'This flower is a lethal weapon used by the Joker to spray his enemies with acid.',
  },

  {
    id: 17,
    name: "DC:Batman's Grappling Gun",
    age: 600,
    rate: 9,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbIQneAwEl8XXigjd1a-cpqo-MKguV44_F-A&usqp=CAU',
    favorite: false,
    description:
      'This gun fires a grappling hook attached to a high-tensile strength line, allowing Batman to scale buildings and traverse long distances.',
  },

  {
    id: 18,
    name: "Marvel:Groot's Flower Pot",
    age: 29,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU--3YcAzb2N-HH5E4U6-2phlOXY5eZrqiWA&usqp=CAU',
    favorite: false,
    description:
      "This flower pot is the perfect addition to any plant lover's collection. What makes this pot special is that it is shaped like Groot, the tree-like alien from the Guardians of the Galaxy. Just be careful not to let it walk away!",
  },
  {
    id: 19,
    name: "Marvel:Black Widow's Widow's Bite",
    age: 199,
    rate: 8,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJxClHg_Vl2ds0wpPv9zSBru89d7S-v23YJg&usqp=CAU',
    favorite: false,
    description:
      "The Widow's Bite is a pair of bracelets worn by Black Widow that can discharge electric shocks of varying intensity. They are perfect for taking down enemies or defending against attacks. Not recommended for children under 12 years old.",
  },
  {
    id: 20,
    name: "Marvel:Hulk's Gamma Ray Canister",
    age: 299,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQVbJRtPfKeCHcvc2uReyMSBcdaYGztoahaw&usqp=CAU',
    favorite: false,
    description:
      "This Gamma Ray canister is similar to the one that turned Bruce Banner into the Hulk. While we don't recommend exposing yourself to Gamma Rays, this canister makes a great addition to any superhero collection.",
  },
  {
    id: 21,
    name: "Marvel:Iron Man's Arc Reactor",
    age: 399,
    rate: 9,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnf2MFW720fodyudWSTSgG99xq0RRocVGsXw&usqp=CAU',
    favorite: false,
    description:
      'The Arc Reactor is a device created by Tony Stark (aka Iron Man) that powers his suit and keeps shrapnel from entering his heart. This replica is perfect for any Iron Man fan or anyone looking to add some high-tech flair to their home.',
  },
  {
    id: 22,
    name: "Marvel:Loki's Chitauri Scepter",
    age: 499,
    rate: 8,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDuMCtD32xrvEtlSCq40_JVg_eQ_muMA2X-w&usqp=CAU',
    favorite: false,
    description:
      'The Chitauri Scepter is a powerful weapon wielded by Loki in The Avengers. It contains the Mind Stone, one of the six Infinity Stones. This replica is perfect for any fan of Loki or the Marvel Cinematic Universe.',
  },
  {
    id: 23,
    name: "Marvel:Star-Lord's Walkman",
    age: 79,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTPwf6d4epMZY1LFtIoqOey-xdCOEq9WucHA&usqp=CAU',
    favorite: false,
    description:
      'This Walkman is just like the one used by Star-Lord in Guardians of the Galaxy. It comes with a mixtape of classic 80s songs, perfect for blasting while saving the galaxy.',
  },
  {
    id: 24,
    name: "Spider-Man:Doctor Octopus' Tentacles",
    age: 899,
    rate: 9,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOX9u2p9A_m-C6tUj3cO3pTtWOxsvwYBUq1w&usqp=CAU',
    favorite: false,
    description:
      'A set of four highly advanced mechanical tentacles, designed by Doctor Octopus for his use in combat and manipulation of objects. Each tentacle is 24 feet long and has a claw-like pincer at the end. They can be controlled through a neural interface, allowing the user to move them with their mind. Made from a durable titanium alloy and powered by a miniature nuclear reactor, they are nearly indestructible.',
  },
  {
    id: 25,
    name: "DC:The Riddler's Cane",
    age: 99,
    rate: 7,
    image: '',
    favorite: false,
    description:
      "The Riddler's signature cane features a question mark on top, and can be used as a stylish accessory or as a weapon in a pinch. Made of sturdy material, this cane is both fashionable and functional.",
  },

  {
    id: 26,
    name: "Marvel:Hawkeye's Bow and Arrow",
    age: 299,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2GCOXVLbHyuNXq8YzorFz94nLmq8OSvMZMg&usqp=CAU',
    favorite: false,
    description:
      "This is Hawkeye's signature weapon, a powerful bow and quiver of trick arrows. The bow is made of durable materials and can be used for both display and cosplay. The arrows come in a variety of types, including explosive and grappling.",
  },
  {
    id: 27,
    name: "Marvel:Black Widow's Costum",
    age: 199,
    rate: 8,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWv9hiG6xm9PXitACZ5y9xsLR5KjAcqmBjUQ&usqp=CAU',
    favorite: false,
    description:
      "The Bite is a wrist-mounted device used by Black Widow to deliver powerful electric shocks. This replica is a sleek and stylish accessory that can be worn on the wrist or attached to clothing. It's not just for looks, though - it can also stun attackers in self-defense.",
  },

  {
    id: 28,
    name: "Marvel:Winter Soldier's Bionic Arm",
    age: 750,
    rate: 7,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6OtrvFTZ17YgPPSAOJ8lQrZxvt3q6ZWOF5w&usqp=CAU',
    description:
      'The cybernetic arm of the Winter Soldier, constructed from vibranium and capable of superhuman strength and advanced weaponry.',
    favorite: false,
  },
  {
    id: 29,
    name: "Marvel:Thanos' Double-Edged Sword",
    age: 1000,
    rate: 9,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmm_k_ZQMvXp9BUIWUgURZPJTAQ0FtmJh1rQ&usqp=CAU',
    description:
      'A massive double-edged sword wielded by Thanos during his quest for the Infinity Stones.',
    favorite: false,
  },
  {
    id: 30,
    name: "Marvel:Black Panther's Vibranium Suit",
    age: 1500,
    rate: 10,
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRk66rIP6AdPalfq6PL1BYEe_-Eub-Ie5-A98_1HxZsWnCGko7r0w4roGF3Lh2LXX4VWcI&usqp=CAU',
    description:
      'The suit worn by the King of Wakanda, made of vibranium and capable of absorbing and redirecting kinetic energy.',
    favorite: false,
  },

  {
    id: 31,
    name: "Marvel:Groot's Twig",
    age: 50,
    rate: 6,
    image: 'https://compote.slate.com/images/6c0bc885-1aac-492f-8d78-d1cbe5944dcc.jpg',
    description: 'A small twig from the sentient tree creature known as Groot.',
    favorite: false,
  },
  {
    id: 32,
    name: "Marvel:Star-Lord's Quad Blasters",
    age: 600,
    rate: 8,
    image:
      'https://cdn.dribbble.com/users/309027/screenshots/6215749/star_lord_element_guns_double_cam_angle_3_l1_2_3_4_4x.jpg?compress=1&resize=400x300&vertical=top',
    description: 'The quad blasters used by Star-Lord, capable of firing high-energy blasts.',
    favorite: false,
  },
  {
    id: 33,
    name: "Marvel:Red Skull's Tesseract Cube",
    age: 1200,
    rate: 7,
    image:
      'https://sportshub.cbsistatic.com/i/2021/03/15/cc390c4e-7e4d-43a4-966d-524beba4167f/red-skull-186301.jpg',
    description:
      'The Tesseract Cube used by the Red Skull to power his weapons and teleportation devices.',
    favorite: false,
  },
  {
    id: 34,
    name: "Marvel:Vision's Solar Jewel",
    age: 900,
    rate: 9,
    image: 'https://i.stack.imgur.com/Vw45Q.jpg',
    description:
      "The Solar Jewel implanted in Vision's forehead, allowing him to manipulate his density and shoot energy beams.",
    favorite: false,
  },
  {
    id: 35,
    name: "X-Man:Cyclops' Visor",
    age: 399,
    rate: 9,
    description: 'A high-tech visor that allows you to shoot powerful optic beams like Cyclops.',
    favorite: false,
    image:
      'https://p.turbosquid.com/ts-thumb/RG/C1An5o/sfaTQd6M/cyclops_visor_01_001_thumbnail_0000/jpg/1463746491/600x600/fit_q87/e0d5719f0d251d9f7e98f43e103129d5b0700ffd/cyclops_visor_01_001_thumbnail_0000.jpg',
  },
  {
    id: 36,
    name: "X-Man:Wolverine's Adamantium Claws",
    age: 799,
    rate: 10,
    description:
      'Get the iconic look of Wolverine with these retractable claws made of indestructible adamantium.',
    favorite: false,
    image:
      'https://static.wikia.nocookie.net/marveldatabase/images/a/a5/Astonishing_X-Men_Vol_3_1_Textless.jpg/revision/latest?cb=20080601124741',
  },
  {
    id: 37,
    name: "X-Man:Storm's Lightning Earrings",
    age: 149,
    rate: 8,
    description: "These earrings generate small lightning bolts, just like Storm's powers.",
    favorite: false,
    image: 'https://i.pinimg.com/originals/ae/40/79/ae40797ff9faa7a0ee65adc36c93c485.jpg',
  },
  {
    id: 38,
    name: "X-Man:Magneto's Helmet",
    age: 299,
    rate: 9,
    description: "Protect your mind from telepathic attacks with this replica of Magneto's helmet.",
    favorite: false,
    image:
      'https://files.cults3d.com/uploaders/15649601/illustration-file/553852a2-649a-4292-8df5-43c3aba4731b/Screen%20Shot%202020-09-01%20at%2011.40.18%20pm.png',
  },
  {
    id: 39,
    name: "X-Man:Jean Grey's Phoenix Necklace",
    age: 199,
    rate: 8,
    description:
      'This necklace contains a small piece of the Phoenix Force, giving the wearer immense power.',
    favorite: false,
    image: '',
  },
  {
    id: 40,
    name: "X-Man:Beast's Glasses",
    age: 99,
    rate: 7,
    description:
      'These glasses enhance your vision and allow you to see in the dark, just like Beast.',
    favorite: false,
    image: 'https://medias.spotern.com/spots/w640/169/169424-1542152850.jpg',
  },
  {
    id: 41,
    name: "X-Man:Mystique's Shapeshifting Serum",
    age: 599,
    rate: 9,
    description: 'This serum allows you to shapeshift into anyone you desire, just like Mystique.',
    favorite: false,
    image: 'https://upload.wikimedia.org/wikipedia/en/6/68/Mystique_%28circa_2020%29.jpg',
  },
  {
    id: 42,
    name: "X-Man:Gambit's Kinetic Cards",
    age: 149,
    rate: 8,
    description:
      "These cards release explosive kinetic energy on impact, just like Gambit's powers.",
    favorite: false,
    image:
      'https://i0.wp.com/www.givewavestudios.com/wp-content/uploads/2021/03/Gambit_LED_3.jpg?fit=2000%2C2000&ssl=1',
  },
  {
    id: 43,
    name: "X-Man:Rogue's Gloves",
    age: 199,
    rate: 7,
    description:
      "These gloves absorb the life force of anyone you touch, just like Rogue's powers.",
    favorite: false,
    image:
      'https://assets.roguefitness.com/f_auto,q_auto,c_fill,g_center,w_500,h_500,b_rgb:f8f8f8/catalog/Straps%20Wraps%20and%20Support%20/Hand%20Protection/Gloves/MG0012/MG0012-TH_mkj8yn.png',
  },
  {
    id: 44,
    name: "X-Man:Nightcrawler's Teleportation Device",
    age: 499,
    rate: 9,
    description: 'This device allows you to teleport short distances, just like Nightcrawler.',
    favorite: false,
    image: 'https://i.ytimg.com/vi/bSWISBmyj4U/maxresdefault.jpg',
  },
  {
    id: 45,
    name: "Deadpool:Deadpool's Swords",
    age: 199,
    image:
      'https://static.wikia.nocookie.net/marveldatabase/images/c/c7/Marvel_Duel_Card_0471.jpg/revision/latest?cb=20220430102928',
    rate: 9,
    description: 'A pair of sharp swords used by the infamous mercenary Deadpool.',
    favorite: false,
  },
  {
    id: 46,
    name: "Deadpool:Deadpool's Mask",
    age: 149,
    image: 'https://i.ebayimg.com/00/s/ODAwWDgwMA==/z/UR4AAOSw5nZdS-r2/$_32.JPG?set_id=880000500F',
    rate: 8,
    description: 'The iconic red and black mask worn by Deadpool to conceal his identity.',
    favorite: false,
  },
  {
    id: 47,
    name: "Deadpool:Deadpool's Grenades",
    age: 99,
    image: 'https://i.pinimg.com/550x/f5/60/1e/f5601e91f56bc197d146cc01a0231352.jpg',
    rate: 7,
    description: 'Explosive grenades used by Deadpool in his combat missions.',
    favorite: false,
  },
  {
    id: 48,
    name: "Deadpool:Deadpool's Katanas",
    age: 249,
    image: 'https://www.sword-buyers-guide.com/images/deadpool-deflecting-bullets.jpg',
    rate: 9,
    description:
      'A pair of Japanese swords with long, curved blades used by Deadpool in his fights.',
    favorite: false,
  },
  {
    id: 49,
    name: "Deadpool:Deadpool's Guns",
    age: 399,
    image:
      'https://imageio.forbes.com/specials-images/imageserve/5e872bfbd00e420007cd4a63/Fortnite-Deadpool-Pistol-Locations/960x0.jpg?format=jpg&width=960',
    rate: 9,
    description: "Deadpool's favorite firearms, capable of shooting various types of ammunition.",
    favorite: false,
  },
  {
    id: 50,
    name: "Deadpool:Deadpool's Suit",
    age: 599,
    image:
      'https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F6%2F2019%2F10%2Fmcddead_fe005-2000.jpg',
    rate: 10,
    description:
      'The iconic red and black suit worn by Deadpool, complete with holsters for his weapons.',
    favorite: false,
  },
  {
    id: 51,
    name: "Deadpool:Deadpool's Belt",
    age: 79,
    image: 'https://i.ebayimg.com/00/s/NjU3WDY1Nw==/z/RN0AAOSwy35hCD3I/$_57.JPG?set_id=8800005007',
    rate: 6,
    description: 'A tactical belt worn by Deadpool to carry his weapons and ammunition.',
    favorite: false,
  },
  {
    id: 52,
    name: "Deadpool:Deadpool's Backpack",
    age: 149,
    image:
      'https://m.media-amazon.com/images/W/IMAGERENDERING_521856-T1/images/I/61a30qnVi9L._AC_UY1000_.jpg',
    rate: 7,
    description: 'A backpack worn by Deadpool to carry additional weapons and supplies.',
    favorite: false,
  },
  {
    id: 53,
    name: "Deadpool:Deadpool's Chimichangas",
    age: 9,
    image: 'https://i.ytimg.com/vi/zsbMxLoPZIs/maxresdefault.jpg',
    rate: 10,
    description: 'The infamous Mexican dish loved by Deadpool, available in a variety of flavors.',
    favorite: false,
  },
  {
    id: 54,
    name: "Deadpool:Deadpool's Unicorn",
    age: 399,
    image: 'https://i.ytimg.com/vi/dw6UHF0uHXM/maxresdefault.jpg',
    rate: 8,
    description: "A stuffed unicorn that serves as Deadpool's companion and mascot.",
    favorite: false,
  },
  {
    id: 55,
    name: 'Spider-Man:Carnage Symbiote',
    age: 1500,
    rate: 4,
    favorite: false,
    description:
      "The Carnage symbiote, an offshoot of the Venom symbiote, enhances its host's physical abilities and grants them the ability to shape-shift their body into weapons.",
    image:
      'https://static.wikia.nocookie.net/marveldatabase/images/0/06/Cletus_Kasady_%28Earth-TRN688%29_and_Carnage_%28Symbiote%29_%28Earth-TRN688%29_from_Venom_Let_There_Be_Carnage_001.jpg/revision/latest?cb=20211004164159',
  },
  {
    id: 56,
    name: 'Spider-Man:Lizard Serum',
    age: 500,
    rate: 4,
    favorite: true,
    description:
      "Dr. Curt Connors' serum that transforms him into the Lizard, giving him superhuman strength and regenerative abilities at the cost of his sanity.",
    image:
      'https://cdnb.artstation.com/p/assets/images/images/001/384/649/large/travis-jackson-inoculationsyring-v1.jpg?1445487190',
  },
  {
    id: 57,
    name: "Spider-Man:Electro's Gauntlets",
    age: 950,
    rate: 4,
    favorite: false,
    description:
      "Electro's gauntlets give him the ability to control and manipulate electricity, allowing him to create devastating shockwaves and blasts.",
    image:
      'https://static.wikia.nocookie.net/batman/images/8/8b/Shock_Glove.jpg/revision/latest?cb=20181019110817',
  },
  {
    id: 58,
    name: "Spider-Man:Mysterio's Illusion Helmet",
    age: 800,
    rate: 3,
    favorite: true,
    description:
      "Mysterio's high-tech helmet allows him to create convincing illusions, making it difficult for his enemies to tell reality from fiction.",
    image: 'https://s29288.pcdn.co/wp-content/uploads/2020/09/mysterio-image-750.jpg',
  },
  {
    id: 59,
    name: 'Spider-Man:Green Goblin Glider',
    age: 1200,
    rate: 4,
    favorite: false,
    description:
      "The Green Goblin's infamous glider, capable of high speeds and maneuverability. Comes equipped with Goblin Bombs for added firepower.",
    image:
      'https://static.wikia.nocookie.net/spiderman-films/images/6/6d/The_goblinglider.jpg/revision/latest?cb=20170316011826',
  },
  {
    id: 60,
    name: 'DC:Batarang',
    age: 25,
    rate: 4,
    favorite: false,
    description: 'A bat-shaped throwing weapon used by Batman.',
    image:
      'https://files.cults3d.com/uploaders/15179484/illustration-file/d9338666-a5e7-417e-9207-d125e8acbfc7/Batarang%20v2.png',
  },

  {
    id: 61,
    name: "DC:Joker's Laughing Gas",
    age: 100,
    rate: 4,
    favorite: false,
    description: 'A toxic gas used by the Joker to induce uncontrollable laughter in his victims.',
    image:
      'https://static.wikia.nocookie.net/evil/images/7/79/The_Joker_Venom.jpg/revision/latest?cb=20171125180009',
  },

  {
    id: 62,
    name: "DC:Two-Face's Coin",
    age: 50,
    rate: 4,
    favorite: false,
    description: 'A two-headed coin used by Two-Face to make decisions.',
    image:
      'https://cdn.shopify.com/s/files/1/0603/8129/8846/products/Twofacecoin_1024x1024@2x.jpg?v=1671806076',
  },
  {
    id: 63,
    name: "DC:Penguin's Umbrella",
    age: 75,
    rate: 4,
    favorite: false,
    description: 'An umbrella used by the Penguin, which can shoot bullets or release gas.',
    image: 'https://i.pinimg.com/originals/10/c0/ad/10c0adecf743fc751629c7f26c07a4c7.jpg',
  },
  {
    id: 64,
    name: "DC:Scarecrow's Fear Toxin",
    age: 150,
    rate: 4,
    favorite: false,
    description: 'A toxin created by the Scarecrow that induces intense fear in its victims.',
    image:
      'https://static.wikia.nocookie.net/evil/images/3/3b/The_Fear_Toxin.jpg/revision/latest?cb=20171126190101',
  },
];
